<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_users"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Rapporteur <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-autocomplete label="Délégué commercial" v-model="resource.protractor" :default="resource.protractor_id" :service="ProtractorService" :callback="addProtractor"></form-autocomplete>
                                <form-autocomplete label="Contractant" v-model="resource.protractor_child" :default="resource.protractor_child_id" :service="ProtractorService" :callback="addProtractorChild"></form-autocomplete>

                                <form-datex label="Start" v-model="resource.date_start" :hide-time="false" time="00:00:00"></form-datex>
                                <form-datex label="End" v-model="resource.date_end" :hide-time="false" time="23:59:59"></form-datex>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

import ProtractorLinkService from './ProtractorLinkService.js';
import Edit from '../../../layouts/Edit.vue';

import ProtractorService from './../protractor/ProtractorService.js';

export default {
    extends: Edit,
    data () {
        return {
            resource: {
                addressable: []
            },
            ProtractorService: null
        }
    },
    mounted: function(){
        this.ProtractorService = ProtractorService;
    },
    methods:{
        addProtractor: function(){

        },
        addProtractorChild: function(){

        },
        resourceLoaded: function(){
            this.localesLoaded = true;
            this.initialize()
        },
        getResource: function(){
            return ProtractorLinkService
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/modules/serevita/protractor-link/Edit.vue